// FilesModal.jsx
import React, { useState, useEffect } from "react";
import { FiX, FiDownload, FiTrash2 } from "react-icons/fi";
import toast from "react-hot-toast";
import { listFiles, downloadFile, deleteFile } from "../../services/api";
import { DataState } from "../../context/DataProvider";
import AttachmentItem, {getFileIcon} from "../chat/AttachmentIcon";

const FilesModal = ({ taskId, onClose }) => {
  const { userGoogleId } = DataState();
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchFiles = async () => {
    setLoading(true);
    try {
      const response = await listFiles(userGoogleId, taskId);
      if (response.error) throw new Error(response.error);
      setFiles(response || []);
    } catch (err) {
      console.error("Error fetching files:", err);
      setError("Failed to load files");
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (fileId) => {
    try {
      const response = await downloadFile(fileId, userGoogleId);
      if (!response.error) {
        window.open(response.url, "_blank");
      } else {
        setError(response.error);
      }
    } catch (error) {
      setError("Error downloading file");
    }
  };

  const handleDelete = async (fileId) => {
    try {
      const response = await deleteFile(fileId, userGoogleId);
      if (response.error) {
        setError(response.error);
      } else {
        toast.success("File deleted successfully");
        setFiles(files.filter((file) => file.file_id != fileId));
        setError(null);
      }
    } catch (error) {
      console.error("Error deleting file:", error);
      setError("Error deleting file");
    }
  };


  useEffect(() => { fetchFiles(); }, [taskId]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white dark:bg-zinc-800 rounded-2xl p-6 w-1/3 shadow-lg">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-zinc-900 dark:text-zinc-100">Files</h2>
          <button onClick={onClose} className="p-1 hover:bg-zinc-700 rounded-full">
            <FiX className="w-5 h-5 text-zinc-500 dark:text-zinc-300" />
          </button>
        </div>
        <div className="max-h-60 overflow-y-auto">
          {loading ? (
            <p className="text-center text-zinc-500">Loading files...</p>
          ) : error ? (
            <p className="text-center text-red-500">{error}</p>
          ) : files.length ? (
            <ul className="space-y-2">
              {files.map((file) => {
                const ext = file.filename?.split(".").pop().toLowerCase() || "";
                return (
                <li key={file.file_id} className="flex justify-between items-center p-2 bg-zinc-100 dark:bg-zinc-700 rounded">
                  <div className="flex items-center space-x-2">
                    {getFileIcon(ext)}
                    <span className="truncate max-w-xs">{file.filename || file.file_id}</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <button onClick={() => handleDownload(file.file_id)} className="p-1 hover:bg-zinc-700 rounded" title="Download">
                      <FiDownload className="w-5 h-5 text-zinc-600 dark:text-zinc-300" />
                    </button>
                    <button onClick={() => handleDelete(file.file_id)} className="p-1 hover:bg-red-600 rounded" title="Delete">
                      <FiTrash2 className="w-5 h-5 text-zinc-600 dark:text-zinc-300" />
                    </button>
                  </div>
                </li>);
              })}
            </ul>
          ) : (
            <p className="text-zinc-500 dark:text-zinc-400">No files connected.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilesModal;
